import isEmpty from 'lodash/isEmpty';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
import uuidV4 from 'uuid/v4';
import Label from 'label-component';
import TimeUtils from 'time-utils';
import Select from 'select-component';
import Sentry from 'sentry';
import SHGlobals from 'sh-globals';

class TimePicker extends Component {
    constructor(props) {
        super(props);

        const {
            step,
            selectedTime
        } = props;

        this._TIME_PICKER_ID = uuidV4();
        this._nativeTimeOptions = [];
        this._times = TimeUtils.getTimes({step});
        this._onIconClick = this._onIconClick.bind(this);
        this._inputChange = this._inputChange.bind(this);
        this._selectChange = this._selectChange.bind(this);

        this.state = {
            selectedTime
        };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        this._times.forEach(time => {
            this._nativeTimeOptions.push({
                value: time.formatted,
                label: time.formatted
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        const {
            selectedTime
        } = nextProps;

        if (!isEmpty(selectedTime) && selectedTime !== this.state.selectedTime) {
            this.setState({
                selectedTime
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            onChange,
            focus
        } = this.props;
        const {
            selectedTime
        } = this.state;

        if (selectedTime !== prevState.selectedTime && onChange) {
            onChange(selectedTime);
        }

        // unfortunately this does not work reliably with native select fields
        // it works in some legacy browsers and doesn't hurt anything in others
        if (focus) {
            this._input.refs.select.focus();
        }
    }

    _onIconClick(evt) {
        if (!SHGlobals.isMobile) {
            this._input.refs.select.focus();
        }
    }

    _inputChange(value) {
        this.setState({
            selectedTime: value
        });
    }

    _selectChange({value}) {
        this.setState({
            selectedTime: value
        });
    }

    _renderInput() {
        const {
            useIcon,
            step,
            placeholder
        } = this.props;
        const {
            selectedTime
        } = this.state;
        const classes = classNames(
            {'TimePicker-select': SHGlobals.isMobile},
            {'TimePicker-input': !SHGlobals.isMobile},
            {'ButtonGroup-last': useIcon}
        );
        Sentry.addData({
            selectedTime: selectedTime,
            step: step
        });
        const timeParts = TimeUtils.getValuesFromString(selectedTime, step);
        let newInputValue = selectedTime;
        let hours = '';
        let mins = '';

        if (timeParts) {
            hours = timeParts.hours;
            mins = timeParts.mins;

            newInputValue = TimeUtils.getFromValuesAsString(hours, mins);
        }

        if (!newInputValue && !placeholder) {
            newInputValue = this._nativeTimeOptions[0].value;
        }

        return (
            <Select
                ref={node => { this._input = node; }}
                className={classes}
                name="time-picker-times"
                value={newInputValue}
                onChange={this._selectChange}
                items={this._nativeTimeOptions}
                icon={(useIcon) ? 'clock' : null}
                size="lg"
                placeholder={(SHGlobals.isMobile) ? ' ' : placeholder}
                onIconClick={this._onIconClick}
            />
        );
    }

    _renderInputContainer() {
        const {
            label,
            useIcon
        } = this.props;
        const containerClasses = classNames(
            'TimePicker-input-container',
            {'TimePicker-input-container-with-icon': useIcon}
        );

        return (
            <div className={containerClasses}>
                {label && <Label>{label}</Label>}
                {this._renderInput()}
            </div>
        );
    }

    render() {
        const {
            className,
            label
        } = this.props;

        const classes = classNames(
            'TimePicker',
            `TimePicker-${this._TIME_PICKER_ID}`,
            {'TimePicker-no-label': !label},
            className
        );

        return (
            <div className={classes}>
                {this._renderInputContainer()}
            </div>
        );
    }
}

TimePicker.propTypes = {
    className: PropTypes.string,
    useIcon: PropTypes.bool,
    label: PropTypes.node,
    placeholder: PropTypes.string,
    /** A string in the format of 'hh:mm A' representing the time which should be selected. */
    selectedTime: PropTypes.string,
    focus: PropTypes.bool,
    step: PropTypes.number,
    onChange: PropTypes.func
};

TimePicker.defaultProps = {
    className: '',
    selectedTime: '',
    useIcon: false,
    label: null,
    step: 30
};

export default TimePicker;



// WEBPACK FOOTER //
// ./frontend/src/js/components/time-picker/TimePicker.jsx